import { PageHeader } from "@/components/PageHeader";
import { PricingSection } from "@/components/sections/PricingSection";
import { FaqSection } from "@/components/sections/FaqSection";
import { CtaBanner } from "@/components/sections/CtaBanner";
import { TrustMarquee } from "@/components/sections/TrustMarquee";

export default function Pricing() {
  return (
    <div data-testid="pricing-page">
      <PageHeader
        eyebrow="Pricing & Plans"
        title={<>Honest pricing. <span className="text-brand-red">No contracts.</span></>}
        sub="Choose a monitoring plan that fits — then change or cancel any time. No activation fees, no penalties, no fine print."
      />
      <TrustMarquee />
      <PricingSection />
      <FaqSection limit={5} />
      <CtaBanner />
    </div>
  );
}
